import { Box, Stack, Typography } from "@mui/material";
import { DebugBox, LoadingBox, useNavigateWithParams } from "@northpowerdev/np-react-utils";
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import { useState } from "react";
import { useEffect } from "react";

import useFetchJson from "../../../data/useFetchJson";
import { StyledDataGrid } from "./DlspStyledDataGrid";
import { hikoAlert } from "../../../utils/HikoAlert";
import { lineStatusTextOrder } from "./LineStatusText";
import { plural, safeFormatDate } from "../../../utils/utilityFunctions";
import DlspTaskStatusChip from "../../styled/DlspTaskStatusChip";


const isoDateStringFormatter = (formatterParams) => safeFormatDate(formatterParams.value, 'd MMM yyyy')
const renderTooHard = (params) => params.row.tooHard ? <ProductionQuantityLimitsIcon /> : ''

const gridColumns = [
    { field: 'statusOfServiceLine',  headerName: 'Service Line Status', flex: 1 },
    { field: 'tooHard',              headerName: 'Priority QA / Too Hard', flex: 0, renderCell: renderTooHard },
    { field: 'icp',                  headerName: 'ICP',                 flex: 1, minWidth: 150 },
    { field: 'stormArea',            headerName: 'Storm Area',          flex: 1 },
    { field: 'dsubSuburb',           headerName: 'Suburb',              flex: 1 },
    { field: 'decommissionDate',     headerName: 'Decom. Date',         flex: 1, valueFormatter: isoDateStringFormatter },
    { field: 'desktopQAOwner',       headerName: 'QA Owner',            flex: 1 },
    // { field: 'visibilityOfFuses',    headerName: 'Fuse Visibility',     flex: 1 },
    // { field: 'statusOfFuses',        headerName: 'Fuse Status',         flex: 1 },
];

export default function DlspDesktopQATaskList() {

    const [orderedTaskList, setOrderedTaskList] = useState([])
    const getTaskListPath = '/bff/decommissioned-lines-service/api/decommissioned-lines/list-desktop-qa-tasks'
    const {
        isLoading: taskListLoading,
        data: taskList, // [{"icp", "status", "stormArea", "dsubSuburb", "decommissionDate", "tooHard", "statusOfServiceLine", "visibilityOfFuses", "statusOfFuses"}, ...]
        } = useFetchJson(getTaskListPath, {}, true) 
    const navigateToTaskDetails = useNavigateWithParams('/dlsp/task/details')

    useEffect(() => {
        if (!taskList) return

        setOrderedTaskList(
            [...taskList].sort((a, b) => {
                const relativePriority = lineStatusTextOrder.indexOf(a.statusOfServiceLine) - lineStatusTextOrder.indexOf(b.statusOfServiceLine)
                console.log(`relativePriority`, a.statusOfServiceLine, b.statusOfServiceLine, lineStatusTextOrder.indexOf(a.statusOfServiceLine), lineStatusTextOrder.indexOf(b.statusOfServiceLine), relativePriority)
                if (relativePriority < 0) {
                    return -1
                }
                if (relativePriority > 0) {
                    return 1
                }
                return 0
            })
        )
    }, [taskList])
    const handleRowClick = (params, event, details) => {
        console.log('handleRowClick', {params, event, details})
        if (!params.row.icp) {
            hikoAlert('No icp in that row!')
            return
        }
        let navigateParams = {icp_number: params.row.icp}
        navigateToTaskDetails(navigateParams)
    }

    return (
        <Box className="Page">
            <h3>Decommissioned Lines Safety Project</h3>
            <Stack direction="row" sx={{alignItems: 'center', justifyContent: 'left'}}>
                <h2>Desktop QA Tasks</h2>
                <DlspTaskStatusChip sx={{pl: 2}} status="Desktop QA" />
            </Stack>

            <LoadingBox loading={taskListLoading}>

                <Typography variant="body1">We found {orderedTaskList?.length || 'no'} task{plural(orderedTaskList?.length)}.</Typography>

                <StyledDataGrid sx={{my:2}} autoHeight rows={orderedTaskList || []}
                    getRowId={(row) => row.icp}
                    columns={gridColumns}
                    onRowClick={handleRowClick}
                    getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'}
                />
                <DebugBox title="taskList" stringify>{taskList}</DebugBox>
            </LoadingBox>


        </Box>
    )
}